import React, { forwardRef } from "react";

import { cn } from "@/lib/utils";

export type TextAreaInputProps = {
  readonly id?: string;
  readonly name: string;
  readonly value: string;
  readonly placeholder?: string;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  readonly onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  readonly onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  readonly autoFocus?: boolean;
  readonly "aria-invalid"?: boolean;
  readonly "aria-describedby": string;
};

const TextAreaInput = forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  function TextAreaInput(props, ref): React.ReactElement {
    const {
      id,
      name,
      placeholder,
      className = "",
      disabled,
      onBlur,
      onChange,
      onFocus,
      autoFocus,
      value,
    } = props;

    return (
      <div className="TextAreaInput relative">
        <textarea
          aria-describedby={props["aria-describedby"]}
          aria-invalid={props["aria-invalid"]}
          className={cn(
            "h-24 resize-none",
            "-ring-offset-1 peer block w-full appearance-none rounded border-none p-3 ring-1 ring-light-grey focus:outline-none focus:ring-1 focus:!ring-blue-400 disabled:text-gray-400 aria-invalid:ring-1 aria-invalid:ring-red aria-invalid:placeholder:text-red",
            "placeholder:!text-secondary",
            className,
            disabled && "cursor-not-allowed opacity-50"
          )}
          disabled={disabled}
          data-field={name}
          id={id}
          name={name}
          placeholder={placeholder}
          ref={ref}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          autoFocus={autoFocus}
        ></textarea>
      </div>
    );
  }
);

TextAreaInput.displayName = "TextAreaInput";

export default TextAreaInput;
